/* eslint-disable */ // cant worry about it rn

import { useEffect, useState } from "react";

import { Routes, Route, useSearchParams } from "react-router-dom";
import CourseListPage from "./CourseListPage2";

import { Course, sendPostReq, User } from "../Scripts/misc";
import Cookies from "universal-cookie";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import CourseDetailsPage from "./CourseDetailsPage";
import NoMatch from "./NoMatch";
import TeacherCourses from "./TeacherCourses";

interface Props {
  token: string,
  clear: Function
}

function RouterPage({token, clear}: Props) {

  let [courses, setCourses] = useState<Course[]>([])
  let [userData, setUserData] = useState<User>()

  const getCourses = async () => {
    let res = await sendPostReq("/api/getCourses", {"token": token})

    if ((res.data instanceof Object)) {setCourses(res.data)}

    console.log(res)

    return
  }

  const getUserData = async () => {
    let res = await sendPostReq("/api/getUserData", {"token": token})

    if ((res instanceof Object) && res.data != "userError") {setUserData(res)}
    
    return
  }

  const logout = () => {
    clear()
    window.location.reload()
    return
  }

  useEffect(() => {
    getUserData()
    getCourses()
  }, [])

  return (
    <>
    <Header logout={logout} isTeacher={userData?.role == "teacher"}/>
    <div style={{marginTop: "12vh", minHeight: "70vh"}}>
      {!userData || !courses.length ? <div className="column center-align" style={{textAlign: "center", width:"100vw"}}>
        <h1 style={{width: "60vw"}}>Váš přihlašovací token je neplatný. Odhlašte se prosím skrz menu vpravo nahoře a nechte si poslat nový přihlašovací odkaz</h1>
      </div> : 
        <Routes>
          {userData?.role == "teacher" ? <>
            <Route path="/" element={<TeacherCourses courses={courses} token={token}/>}/>
            <Route path="/editCourse" element={courses.length ? <CourseDetailsPage token={token} courses={courses} getCourses={getCourses}/> : <div>loading</div>}/>
          </> : <>
            <Route path="/" element={<CourseListPage token={token} courses={courses}/>} />
          </>}

          <Route path="*" element={<NoMatch/>}/>
        </Routes>}
        
        </div>
        <Footer/>
    
    </>
  );
}

export default RouterPage;
